/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from "react";
import { ILayout, useLayout } from "../../core";

const Footer = () => {
  const { config } = useLayout();
  useEffect(() => {
    updateDOM(config);
  }, [config]);
  return (
    <>
      <div className="text-dark order-2 order-md-1 py-3 fs-6">
        <span className="text-gray-600 fw-semibold me-1">
          {new Date().getFullYear().toString()} &copy;
        </span>
        <a
          href="https://getsmoodi.com"
          target="_blank"
          className="text-gray-900 text-hover-primary"
        >
          Smoodi
        </a>
      <span className="text-gray-600">. All rights reserved.</span>
      </div>
    </>
  );
};

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add("data-kt-app-footer-fixed", "true");
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add("data-kt-app-footer-fixed-mobile", "true");
  }
};

export { Footer };
